import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import CreateJobInput from '../CreateJob/CreateJobInput'
import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { faStar as emptyStar } from '@fortawesome/free-regular-svg-icons'
import { useDispatch } from 'react-redux'
import { createJobScreening } from 'store/Recruitment/actions'
import AxiosInstance from 'utils/AxiosInstance'
import { setFormSubmitted } from 'store/Recruitment/actions'
import { updateJobScreening } from 'store/Recruitment/actions'

function CreateJobScreening({ showModal, setShowModal, jobScreening }) {
  const dispatch = useDispatch()

  const [rating, setRating] = useState(0)
  const [permRating, setPermRating] = useState(0)

  const [question, setQuestion] = useState('')
  const [isRequired, setIsRequired] = useState(null)
  const [screeningType, setScreeningType] = useState(null)
  const [screenIndicator, setScreenIndicator] = useState(null)

  const emptyStars = Array.from({ length: 5 }, (_, i) => i)

  const [screeningTypeOptions, setScreeningTypeOptions] = useState([])
  const [screenIndicatorOptions, setScreenIndicatorOptions] = useState([])

  useEffect(() => {
    AxiosInstance.get(
      `/recruitment/setup/screening_type,screen_indicator`
    ).then((data) => {
      setScreeningTypeOptions(
        data.screening_type.map((el) => {
          return { name: el.value, value: el.value, id: el.id }
        })
      )
      setScreenIndicatorOptions(
        data?.screen_indicator?.flat()?.map((el) => {
          return { name: el.value, value: el.value, id: el.id }
        })
      )
    })
  }, [])

  useEffect(() => {
    if (jobScreening) {
      const screeningType = screeningTypeOptions?.find(
        (el) => el.id === jobScreening?.screening_type_id
      )
      const screenIndicator = screenIndicatorOptions?.find(
        (el) => el.id === jobScreening?.screening_indicator_id
      )

      setQuestion(jobScreening.question)
      setIsRequired(
        jobScreening.is_required
          ? { name: 'Yes', value: 1 }
          : { name: 'No', value: 0 }
      )
      setScreeningType(screeningType)
      setScreenIndicator(screenIndicator)
      setRating(jobScreening.rating)
      setPermRating(jobScreening.rating)
    }
  }, [jobScreening, screenIndicatorOptions, screeningTypeOptions])

  return (
    <Modal
      isOpen={showModal}
      toggle={() => setShowModal(false)}
      size='lg'
      centered
      scrollable
    >
      <ModalHeader className='border-bottom' toggle={() => setShowModal(false)}>
        Create Job screening
      </ModalHeader>
      <ModalBody className='scrollbar'>
        <form
          id='jobScreening'
          onSubmit={(e) => {
            e.preventDefault()

            dispatch(setFormSubmitted(true))

            const isValid =
              question.trim() &&
              isRequired !== null &&
              screeningType &&
              screenIndicator

            if (!isValid) {
              return
            }

            const payload = {
              question,
              is_required: isRequired?.option?.value || 0,
              screening_type_id: screeningType?.option?.id,
              screening_indicator_id: screenIndicator?.option?.id,
              rating: permRating,
            }

            if (!jobScreening) {
              dispatch(createJobScreening(payload))
            } else {
              dispatch(updateJobScreening(jobScreening.id, payload))
            }

            setShowModal(false)
          }}
        >
          <CreateJobInput
            id='question'
            placeholder='Enter question'
            label='Question'
            required={true}
            fullSize={false}
            onChange={(val) => setQuestion(val)}
            defaultValue={question}
          />
          <div className='d-flex' style={{ gap: '2rem' }}>
            <CreateJobInput
              id='isRequired'
              placeholder='Select Is Required'
              label='Is Required'
              required={true}
              fullSize={false}
              select={true}
              options={[
                { name: 'Yes', value: 1 },
                { name: 'No', value: 0 },
              ]}
              onChange={(val) => setIsRequired(val)}
              selectedOptions={isRequired}
            />
            <CreateJobInput
              id='screeningType'
              placeholder='Select Screening Type'
              label='Screening Type'
              required={true}
              fullSize={false}
              select={true}
              options={screeningTypeOptions}
              onChange={(val) => setScreeningType(val)}
              selectedOptions={screeningType}
            />
          </div>
          <div className='d-flex' style={{ gap: '2rem' }}>
            <CreateJobInput
              id='screenIndicator'
              placeholder='Select Screen Indicator'
              label='Screen Indicator'
              required={true}
              fullSize={false}
              select={true}
              options={screenIndicatorOptions}
              onChange={(val) => setScreenIndicator(val)}
              selectedOptions={screenIndicator}
            />
            <div className='w-50 d-flex flex-column align-items-start ml-3'>
              <label className='form-control-label' htmlFor={`field-`}>
                Rating
              </label>
              <div
                onMouseLeave={() => {
                  setRating(permRating)
                }}
                className='d-flex align-items-center justify-content-center'
                style={{ gap: '0.5rem' }}
              >
                {emptyStars.map((star, i) =>
                  i + 1 <= rating ? (
                    <FontAwesomeIcon
                      onMouseEnter={() => setRating(i + 1)}
                      onClick={() => {
                        setPermRating(i + 1)
                      }}
                      key={i}
                      icon={faStar}
                      className='text-warning'
                      size='lg'
                      style={{ cursor: 'pointer' }}
                    />
                  ) : (
                    <FontAwesomeIcon
                      onMouseEnter={() => setRating(i + 1)}
                      onClick={() => {
                        setPermRating(i + 1)
                      }}
                      key={i}
                      icon={emptyStar}
                      className='text-warning'
                      size='lg'
                      style={{ cursor: 'pointer' }}
                    />
                  )
                )}
              </div>
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <CancelModalButton
          customFn={() => setShowModal(false)}
        ></CancelModalButton>
        <SubmitModalButton
          text={!jobScreening ? 'Create' : 'Update'}
          form='jobScreening'
        ></SubmitModalButton>
      </ModalFooter>
    </Modal>
  )
}

export default CreateJobScreening
